import { WebPlugin } from '@capacitor/core';
export class ChromaprintWeb extends WebPlugin {
    async fingerprint(options) {
        const { path } = options;
        console.log('Fingerprinting file at path:', path);
        throw new Error('Fingerprinting is not available on web.');
    }
}
//# sourceMappingURL=web.js.map